import React, { useState } from "react";

import { IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";

import { MapInfoBody, MapInfoTitle } from "./mapInfo";
import InfoDialog from "../modals/InfoDialog";

const MapInfoIcon = ({ infoDialogProps }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <IconButton
        aria-label="Open Map Information"
        onClick={() => setOpen(true)}
        sx={{ ml: 1 }}
      >
        <InfoIcon fontSize="large" />
      </IconButton>
      <InfoDialog
        open={open}
        setOpen={setOpen}
        DialogTitle={MapInfoTitle}
        DialogBody={MapInfoBody}
        showCiuLogo />
    </>
  );
};

export default MapInfoIcon;
